import angular from 'angular';
import DefaultGrouping from './default';

class ContentGrouping extends DefaultGrouping {
  constructor($sce) {
    super();

    this.trust = $sce.trustAsHtml;

    this.key = 'content';
    this.displayName = 'Content';
    this.groupByPulldown = false;
    this.secondarySortable = false;
  }

  // Content needs to be trusted as html to allow for style attrs on spans
  getDisplayText(content) {
    return this.trust(content);
  }

  getDocDisplayStyles() {
    var result = this.getDocDisplayStyles();
    result['width'] = 'auto';
    return result;
  }

  getDocDisplayText(value) {
    return this.getDisplayText(value);
  }

  getMemoText(value) {
    return this.getDisplayText(value);
  }
}
ContentGrouping.$inject = ['$sce'];

export default angular.module('groupings.content-grouping', [])
  .service('ContentGrouping', ContentGrouping)
  .name;



// WEBPACK FOOTER //
// ./project/groupings/content.js